module.exports = __webpack_public_path__ + "img/182.780fbb8c.jpg";